module.exports = __webpack_public_path__ + "static/media/17_calibre.92bed68e.svg";